import React, { useState, useMemo } from "react";
import LeadDetailModal from "../../Lead/Views/LeadDetail";
import OppurtunityDetailModal from "../../Oppurtunity/Views/OppurtunityDetail";
import JobDetailModal from "../../Jobs/View/JobDetail";
import CreateCustomerModal from "../../Customer/View/CreateCustomer";

const getInitials = (name) => {
    if (!name || typeof name !== "string") return "?";
    const parts = name.trim().split(" ").filter(Boolean);
    if (parts.length === 0) return "?";
    if (parts.length === 1) return parts[0][0].toUpperCase();
    return (parts[0][0] + parts[1][0]).toUpperCase();
};

const colors = [
    "#d9534f", "#5bc0de", "#5cb85c", "#f0ad4e", "#0275d8",
    "#6f42c1", "#20c997", "#6610f2", "#e83e8c", "#17a2b8"
];

const CardListView = ({ data, onLeadModalClose }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [searchText, setSearchText] = useState("");
    const rowsPerPage = 8;

    const [selectedLeadID, setLeadID] = useState("0");
    const [selectedOpportunityID, setOpportunityID] = useState("0");
    const [selectedJobID, setJobID] = useState("0");

    const [selectedLeadDetailID, setLeadDetailID] = useState("0");
    const [selectedOpportunityDetailID, setOpportunityDetailID] = useState("0");
    const [selectedCustomerID, setCustomerID] = useState("0");

    const [selectedLeadCommID, setSelectedLeadCommID] = useState("0");
    const [selectedOpporCommID, setSelectedOpporCommID] = useState("0");
    const [selectedCustCommID, setSelectedCustCommID] = useState("0");

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isOpportunityModalOpen, setIsOpportunityModalOpen] = useState(false);
    const [isJobModalOpen, setIsJobModalOpen] = useState(false);
    const [isTaskModalOpen, setIsTaskModalOpen] = useState(false);
    const [isLeadModalOpen, setIsLeadModalOpen] = useState(false);
    const [isCustomerModalOpen, setIsCustomerModalOpen] = useState(false);
    const [isCustomerDetailModalOpen, setIsCustomerDetailModalOpen] = useState(false);

    // Filter data based on searchText (name, company, email)
    const filteredData = useMemo(() => {
        if (!searchText) return data;
        const lowerSearch = searchText.toLowerCase();
        return data.filter((item) =>
            (item.name || item.label || "").toLowerCase().includes(lowerSearch) ||
            (item.company || "").toLowerCase().includes(lowerSearch) ||
            (item.email || "").toLowerCase().includes(lowerSearch)
        );
    }, [data, searchText]);

    const totalPages = Math.ceil(filteredData.length / rowsPerPage);
    const currentData = filteredData.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );

    if (!data || data.length === 0) return <div>No data available</div>;

    const handleCreateLeadClick = (event, ID, Module, item) => {
        event.stopPropagation();
        if (Module === "Lead") {
            setLeadID(ID);
            setIsModalOpen(true);
        } else if (Module === "Opportunity") {
            setOpportunityID(ID);
            setIsOpportunityModalOpen(true);
        } else if (Module === "Job") {
            setJobID(ID);
            setIsJobModalOpen(true);
        } else if (Module === "LeadDetail") {
            setLeadDetailID(item.Lead_ID);
            setSelectedLeadCommID(ID);
            setIsLeadModalOpen(true);
        } else if (Module === "OpportunityDetail") {
            setOpportunityDetailID(item.Opportunity_ID);
            setSelectedOpporCommID(ID);
            setIsTaskModalOpen(true);
        } else if (Module === "CustomerDetail") {
            setCustomerID(item.CustomerID);
            localStorage.setItem('ClientCompanyID', item.CustomerID);
            setSelectedCustCommID(ID);
            setIsCustomerModalOpen(true);
        }
        else if (Module === "Customer") {
            setCustomerID(item.ID);
            localStorage.setItem('ClientCompanyID', item.ID);           
            setIsCustomerDetailModalOpen(true);
        }


        
    };

    const handleCloseModal = async (event) => {
        event.stopPropagation();
        setLeadID("0");
        setOpportunityID("0");
        setJobID("0");
        setIsModalOpen(false);
        setIsOpportunityModalOpen(false);
        setIsJobModalOpen(false);
        setIsLeadModalOpen(false);
        setIsTaskModalOpen(false);
        setIsCustomerModalOpen(false);
        onLeadModalClose();
        setIsCustomerDetailModalOpen(false);
    };

    return (
        <div style={{ height: "100%", display: "flex", flexDirection: "column", width: "100%" }}>
            {/* Search Box */}
            <div>
                <input
                    type="text"
                    className="form-control"
                    placeholder="Search..."
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    onClick={(e) => e.stopPropagation()} // prevent bubbling
                    style={{"width":"50%","float":"right","marginRight":"5px"}}
                />
            </div>

            {/* Cards */}
            {currentData.map((item, idx) => {
                const initials = getInitials(item.name || item.label);
                const color = colors[idx % colors.length];
                return (
                    <div
                        key={idx}
                        className="table-row"
                        style={{
                            display: "flex",
                            alignItems: "center",
                            padding: "10px",
                            borderBottom: "1px solid #f1f1f1",
                        }}
                    >
                        <div style={{ display: "flex", alignItems: "center", flex: 1 }}>
                            <div
                                style={{
                                    background: color,
                                    color: "#fff",
                                    borderRadius: "50%",
                                    width: "40px",
                                    height: "40px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontWeight: "bold",
                                    fontSize: "14px",
                                    marginRight: "12px",
                                }}
                            >
                                {initials}
                            </div>
                            <div
                                style={{ cursor: "pointer" }}
                                onClick={(event) => handleCreateLeadClick(event, item.ID, item.Module, item)}
                            >
                                <div style={{ fontWeight: "bold", color: "#0275d8" }}>
                                    {item.name || item.label}
                                </div>
                                {item.company && <div style={{ fontSize: "13px", color: "#555" }}>{item.company}</div>}
                                {item.email && (
                                    <div
                                        style={{ fontSize: "12px", color: "#888" }}
                                        dangerouslySetInnerHTML={{ __html: item.email }}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                );
            })}

            {/* Pagination */}
            {totalPages > 1 && (
                <div style={{ padding: "6px", textAlign: "center", borderTop: "1px solid #eee", fontSize: "13px" }}>
                    <button
                        className="btn btn-sm btn-light mx-1"
                        onClick={(e) => { e.stopPropagation(); setCurrentPage(p => Math.max(p - 1, 1)); }}
                        disabled={currentPage === 1}
                    >
                        Prev
                    </button>
                    Page {currentPage} of {totalPages}
                    <button
                        className="btn btn-sm btn-light mx-1"
                        onClick={(e) => { e.stopPropagation(); setCurrentPage(p => Math.min(p + 1, totalPages)); }}
                        disabled={currentPage === totalPages}
                    >
                        Next
                    </button>
                </div>
            )}

            {/* Modals */}
            <div className="lead-modal">
                {isModalOpen && <LeadDetailModal LeadID={selectedLeadID} onClose={handleCloseModal} onSuccess={onLeadModalClose} IsDiaries={"0"} CommunicationID={"0"} onNext={"1"} onPrevious={"0"} />}
                {isOpportunityModalOpen && <OppurtunityDetailModal OpportunityID={selectedOpportunityID} onClose={handleCloseModal} onSuccess={onLeadModalClose} IsDiaries={"0"} CommunicationID={"0"} onNext={"1"} onPrevious={"0"} />}
                {isJobModalOpen && <JobDetailModal JobID={selectedJobID} onClose={handleCloseModal} onSuccess={onLeadModalClose} CustomerID={"0"} engineersData={[]} />}
                {isTaskModalOpen && <OppurtunityDetailModal OpportunityID={selectedOpportunityDetailID} onClose={handleCloseModal} onSuccess={onLeadModalClose} IsDiaries={"1"} CommunicationID={selectedOpporCommID} />}
                {isLeadModalOpen && <LeadDetailModal LeadID={selectedLeadDetailID} onClose={handleCloseModal} onSuccess={onLeadModalClose} IsDiaries={"1"} CommunicationID={selectedLeadCommID} />}
                {isCustomerModalOpen && <CreateCustomerModal ClientCompanyID={selectedCustomerID} onClose={handleCloseModal} onSuccess={onLeadModalClose} IsCustomerSelection={"0"} IsDiaries={"1"} CommunicationID={selectedCustCommID} />}
                 {isCustomerDetailModalOpen && <CreateCustomerModal ClientCompanyID={selectedCustomerID} onClose={handleCloseModal} onSuccess={onLeadModalClose}   />}
            </div>
        </div>
    );
};

export default CardListView;
